import React from 'react'

import LabelTitleText from 'components/shared/LabelTitleText'
import SectionHeaderWithTriangleImage from 'components/shared/SectionHeaderWithTriangleImage'
import Separator from 'components/shared/Separator'
import KeyNumbers from 'components/shared/KeyNumbers'
import Layout from 'components/shared/Layout'

import css from './styles.module.scss'

const TextWithKeyNumbers = ({ className, triangleImage, intro, keyNumber }) => {
  return (
    <SectionHeaderWithTriangleImage
      className={className}
      triangleImage={triangleImage}
    >
      <Layout type="wrapper" className={css.wrapper}>
        <Layout type="smallInnerWrapper">
          {intro && (
            <>
              <LabelTitleText className={css.text} {...intro} />
              <Separator />
            </>
          )}
          {keyNumber && (
            <KeyNumbers className={css.keyNumbers} keyNumbers={keyNumber} />
          )}
        </Layout>
      </Layout>
    </SectionHeaderWithTriangleImage>
  )
}

TextWithKeyNumbers.defaultProps = {}

export default TextWithKeyNumbers
